import { render, staticRenderFns } from "./DepartmentsCRUD.vue?vue&type=template&id=7d758a82&"
import script from "./DepartmentsCRUD.vue?vue&type=script&lang=js&"
export * from "./DepartmentsCRUD.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports